import { render, staticRenderFns } from "./CustomerFormDetail.vue?vue&type=template&id=39fe92dc&"
import script from "./CustomerFormDetail.vue?vue&type=script&lang=js&"
export * from "./CustomerFormDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports